import type { TranslationMessages } from '../../types';

export const attendance: TranslationMessages = {
  title: 'Check-in / Check-out',
  subtitle: 'Track your work hours and attendance',
  checkin: 'Check In',
  checkout: 'Check Out',
  checking_in: 'Checking In...',
  checking_out: 'Checking Out...',
  current_status: 'Current Status',
  checked_in: 'Checked In',
  checked_out: 'Checked Out',
  status_working: 'Working',
  status_off_duty: 'Off Duty',
  status_on_break: 'On Break',
  status_since: 'Since',
  unknown: 'Unknown',
  checkin_time: 'Check In Time',
  checkout_time: 'Check Out Time',
  work_duration: 'Work Duration',
  break_time: 'Break Time',
  start_break: 'Start Break',
  end_break: 'End Break',
  break_duration: 'Break Duration',
  today_hours: "Today's Hours",
  total_hours: 'Total Hours',
  break_hours: 'Break Time',
  overtime_hours: 'Overtime',
  weekly_hours: 'Weekly Hours',
  monthly_hours: 'Monthly Hours',
  location_detected: 'Location detected',
  location_not_available: 'Location not available',
  notes_optional_label: 'Notes (Optional)',
  notes_placeholder: 'Add any notes about your check-in/check-out...',
  refresh_status: 'Refresh',
  refresh_success: 'Status refreshed successfully',
  refresh_error: 'Failed to refresh status',
  login_required_message: 'Please log in to access check-in/check-out',
  break_quick_action_title: 'Break Time',
  break_quick_action_start: 'Start Break',
  break_quick_action_end: 'End Break',
  break_quick_action_label: 'Break Time',
  break_dialog_title: 'Break Time',
  break_dialog_need_checkin: 'You need to check in first before taking a break.',
  break_dialog_end_question:
    'You are currently on break. Do you want to end your break?',
  break_dialog_start_question: 'Do you want to start your break?',
  break_dialog_checkin_first: 'Check In First',
  view_timesheet: 'View Timesheet',
  view_timesheet_opening: 'Opening timesheet...',
  view_timesheet_navigate_message:
    'Please navigate to the Attendance tab to view your timesheet',
};
